import AuthService from "../../intranet/auth/auth_service";

export default class EquipamentService extends AuthService {
  constructor() {
    super("equipamento");
  }

  changeStatus(id) {

    return this.execute("PUT", `/status/${id}`);

  }
}
